<template>
  <div class="vidclbanner">
    <div class="top between">
      <div class="vidc_left">
        <el-carousel
          height="466px"
          indicator-position="none"
          ref="vidclbanner"
          @change="swichan"
          arrow="never"
          @mouseenter.native="autoplayHandler"
        >
          <el-carousel-item
            v-for="(item,index) in al"
            :key="index"
            @click.native="tojump(item)"
          >
            <img :src="item.preview_pic" />
          </el-carousel-item>
        </el-carousel>
        <div class="vidc_lebottom between">
          <div class="des" v-if="al[swiactiv]&&al[swiactiv].title">
            <img
              src="~assets/claim/bofang.png"
              alt=""
            />{{al[swiactiv].title || ''}}
          </div>
          <div class="flex_end">
            <div
              class="switm_yd"
              v-for="(item, index) in al"
              :key="index"
              :class="{ activ: swiactiv == index }"
              @click="setswi(index)"
            ></div>
          </div>
        </div>
      </div>
      <div class="vidc_right">
        <div class="vritem" v-for="(item, index) in bl" :key="index" @click="tojump(item)">
          <div>
            <img :src="item.preview_pic" />
          </div>
          <div class="text">{{item.title}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    swiactiv: 0,
    al:[],
    bl:[],
  }),
  beforeMount() {
    this.getalist()
    this.getblist()
  },
  methods: {
    autoplayHandler() {
      this.$refs.vidclbanner.handleMouseEnter = () => {};
    },
    swichan(index) {
      this.swiactiv = index;
    },
    setswi(index) {
      this.$refs.vidclbanner.setActiveItem(index);
    },
    tojump(item) {
      this.$router.push({
        path: "/laws/videoimdet",
        query: {
          videoinId: item.id,
        },
      });
    },
    getalist() {
      this.$http.laws
        .getvideolist({
          limit: 6,
          order: "hot",
          page: 1,
        })
        .then((res) => {
          this.al = res.data.data;
        });
    },
    getblist() {
      this.$http.laws
        .getvideolist({
          limit: 2,
          order: "hot",
          page: 4,
        })
        .then((res) => {
          this.bl = res.data.data;
        });
    },
  },
};
</script>

<style lang="scss" scope>
.vidclbanner {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .top {
    .vidc_left {
      width: 853px;
      height: 466px;
      position: relative;
      .vidc_lebottom {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 64px;
        line-height: 64px;
        color: #fff;
        background-color: rgba($color: #000000, $alpha: 0.2);
        padding: 0 40px 0 27px;
        cursor: pointer;
        .des {
          font-size: 22px;
          color: #ffffff;
          img {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            margin-right: 12px;
          }
        }
        .switm_yd {
          width: 12px;
          height: 12px;
          background: #ffffff;
          border-radius: 50%;
          margin-right: 14px;
          &.activ {
            background: #0465ea;
          }
        }
      }
    }
    .vidc_right {
      width: 317px;
      height: 466px;
      .vritem {
        margin-bottom: 24px;
        cursor: pointer;
        img {
          width: 317px;
          height: 180px;
        }
        .text {
          margin-top: 18px;
          font-size: 18px;
          color: #333333;
        }
      }
    }
  }
}
</style>